import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { withRouter, Link, useHistory } from "react-router-dom";
import "../private-chatbot.css";
import { useDispatch } from "react-redux";
import {
  Button,
  Offcanvas,
  Form,
  Collapse,
  InputGroup,
  Dropdown,
  Modal,
} from "react-bootstrap";
import { auth } from "../Authentication/firebase/firebase";
import { doSignOut } from "../Authentication/firebase/auth";
import API_Root from "../Constants/API_Root";
import { toggleToast } from "../Actions/ToggleToast";
import userProfileImage from "../App/Img/profile-user.png";
import yourLogoImage from "../App/Img/masked.png";
import AppCanvas from "./Canvass";
import AdminModel from "./AdminModel/AdminModel";
import { authFetch } from "../Authentication/authService";

export default function PrivatESRAResponsive() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [filesOpen, setFilesOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [userEmail, setUserEmail] = useState();
  const [iseLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [firstName, setFirstName] = useState("None");
  const [lastName, setLastName] = useState("None");
  const [pocAccess, setPocAccess] = useState(false);
  const [userEmails, setUserEmails] = useState("");
  const [sessions, setSessions] = useState([]);
  const [newSessionId, setNewSessionId] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [currentTeamName, setCurrentTeamName] = useState("");
  const [filenames, setFilenames] = useState([]);
  const [switchTeams, setSwitchTeams] = useState([]);
  const [lastSynced, setLastSynced] = useState(null);
  const [organizationEmails, setOrganizationEmails] = useState([]);

  const [messagess, setMessagess] = useState([]);

  //renaming session -
  const [rename, setrename] = useState(false);
  const [renamedSessionId, setRenamedSessionId] = useState(null);
  //Admin Pannel states -
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [createTeamButton, setCreateTeamButton] = useState(false);
  const [inviteTeamName, setInviteTeamName] = useState("");
  const [fullTeam, setFullTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [inviteMode, setInviteMode] = useState("default"); // "default" or "add"
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteRole, setInviteRole] = useState("user");
  const [showAddMemberForm, setShowAddMemberForm] = useState(false);
  const [editTeamId, setEditTeamId] = useState(null);
  const [filesForApproval, setFilesForApproval] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [ingestionJobId, setIngestionJobId] = useState(
    localStorage.getItem("ingestionJobId") || null
  );
  const [stateIngestionJobId, setStateIngestionJobId] = useState("");
  const [teamStorageUsage, setTeamStorageUsage] = useState(0);

  // Chatting implementation -
  const [anonymous, setAnonymous] = useState(false);
  const [responseType, setResponseType] = useState("Text");
  const [message, setMessage] = useState("");
  const [newMessage, setNewMessage] = useState([]);
  const [selectedModel, setSelectedModel] = useState("llama38b");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedApprovedFiles, setSelectedApprovedFiles] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const [isRightPanelCollapsed, setIsRightPanelCollapsed] = useState(false);
  const [teamMembersDialoag, setTeamMembersDialog] = useState(false);
  const [selectedSwitchTeam, setSelectedSwitchTeam] = useState("");
  const [canvasMessage, setCanvasMessage] = useState([]);

  const [showTools, setShowTools] = useState(false);
  const [minimizedTools, setMinimizedTools] = useState(false);

  // benchmarking states
  const [showBenchmarkModal, setShowBenchmarkModal] = useState(false);
  const [benchmarkProgress, setBenchmarkProgress] = useState(0);
  const [benchmarkRunning, setBenchmarkRunning] = useState(false);
  const [benchmarkStandard, setBenchmarkStandard] = useState("");

  const [benchmarkLocalFiles, setBenchmarkLocalFiles] = useState([]); // drag/upload files
  const [benchmarkKBFiles, setBenchmarkKBFiles] = useState([]); // selected from KB

  const [dragActive, setDragActive] = useState(false);
  const [askUploadKB, setAskUploadKB] = useState(false);

  //Esap
  const [showESAPModal, setShowESAPModal] = useState(false);
  const [esapRunning, setEsapRunning] = useState(false);
  const [esapProgress, setEsapProgress] = useState(0);

  const [esapLocalFiles, setEsapLocalFiles] = useState([]);
  const [esapKBFiles, setEsapKBFiles] = useState([]);

  const [esapStandard, setEsapStandard] = useState(""); // optional
  const [esapAskUploadKB, setEsapAskUploadKB] = useState(false);
  const [esapError, setEsapError] = useState("");

  // ESDD states
  const [showESDDModal, setShowESDDModal] = useState(false);
  const [esddRunning, setEsddRunning] = useState(false);
  const [esddProgress, setEsddProgress] = useState(0);

  const [esddLocalFiles, setEsddLocalFiles] = useState([]);
  const [esddKBFiles, setEsddKBFiles] = useState([]);

  const [esddStandard, setEsddStandard] = useState("");
  const [esddAskUploadKB, setEsddAskUploadKB] = useState(false);
  const [esddError, setEsddError] = useState("");

  const [openModule, setOpenModule] = useState(false);

  console.log(filenames, "files")

  // Chat messages
  const [messages, setMessages] = useState([
    { sender: "assistant", text: "Hello! How can I help you today?" },
    { sender: "user", text: "Hi, I need some help with ESRA files." },
  ]);

  const FILTERS = {
    Governance: ["Assessments", "ESMS"],
    Social: ["Labour", "Heritage", "Community"],
    Environment: ["Resources", "Biodiversity", "Climate Change"],
  };
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");

  const chatEndRef = useRef(null);
  const canvasRef = useRef(null);

  // Equivalent to componentDidMount
  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!loggedIn) {
      history.push("/login");
    }

    setIsLoggedIn(loggedIn);

    // Firebase auth listener
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsLoggedIn(true);
        setUserEmail(user.email);

        // Call functions after state is set
        fetchUserRole(user.email);
        fetchProfileInformation(user.email);
        fetchDemoSessions(user.email);
        fetchTeamMembers(user.email);
        fetchDemoFiles(user.email);
        fetchTeams(user.email);
        fetchTeamInfo(user.email);
        fetchFilesForApproval();

        if (localStorage.getItem("syncing") === "true") {
          handleCheckSyncStatus();
        }
      } else {
        setIsLoggedIn(false);
        setUserEmail(null);
      }
    });

    // Initial API call
    fetchOrganizationEmails();

    // Click event
    // document.addEventListener("click", handleClickOutside);

    // cleanup
    return () => {
      unsubscribe();
      // document.removeEventListener("click", handleClickOutside);
    };
  }, []); // empty array = run once on mount

  const selectChatSession = (e, session_id) => {
    if (e) {
      e.preventDefault();
    }

    setSessionId(session_id);
    setNewMessage([]); // reset safely

    authFetch(`${API_Root}session/demo-fetch-session-messages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // ✅ ALWAYS set array
        setNewMessage(Array.isArray(data.messages) ? data.messages : []);
      })
      .catch((error) => {
        console.error("Error fetching session messages:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const fetchUserRole = (email) => {
    authFetch(API_Root + "team/get-user-role", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setIsAdmin(data.role === "admin");
      })
      .catch((error) => {
        console.error("Error fetching user role:", error);
      });
  };

  const fetchProfileInformation = (email) => {
    authFetch(API_Root + "users/get-profile-information", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        ip_address: ipAddress,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const first = data.myesra_subscription.first_name || "None";
        const last = data.myesra_subscription.last_name || "None";
        const access = data.myesra_subscription.access || false;

        setFirstName(first);
        setLastName(last);
        setPocAccess(access);

        if (!access) {
          history.push("/");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const fetchDemoSessions = (email) => {
    authFetch(`${API_Root}session/fetch-demo-sessions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email }), // from useState
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setSessions(data.sessions || []);
        setNewSessionId(data?.sessions?.[0] || []);
      })
      .catch((error) => {
        console.error("Error fetching demo sessions:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const fetchTeamMembers = (email) => {
    authFetch(API_Root + "team/get-team-members", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email }), // from useState
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const { team_id, team_name, members } = data;

        setSelectedTeamId(team_id);
        setTeamMembers(members);
        setCurrentTeamName(team_name);
      })
      .catch((error) => {
        console.error("Error fetching team members:", error);
      });
  };

  const fetchDemoFiles = (email) => {
    authFetch(`${API_Root}team/get-demo-files`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email }), // from useState
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setFilenames(data.files || []);
      })
      .catch((error) => {
        console.error("Error fetching demo files:", error);

        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const fetchTeams = (email) => {
    authFetch(`${API_Root}team/demo-fetch-teams`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email }), // from useState
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setSwitchTeams(data.teams || []);
      })
      .catch((error) => {
        console.error("Error fetching teams:", error);
      });
  };

  const filteredFiles = filenames?.filter((file) => {
    const categoryMatch = selectedCategory
      ? file?.metadata?.category === selectedCategory
      : true;

    const subcategoryMatch = selectedSubcategory
      ? file?.metadata?.subcategory === selectedSubcategory
      : true;

    return categoryMatch && subcategoryMatch;
  });

  const fetchTeamInfo = (email) => {
    authFetch(`${API_Root}team/demo-get-team-info`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email }), // from useState
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.last_synced) {
          setLastSynced(data.last_synced);
        }
      })
      .catch((error) => {
        console.error("Error fetching team info:", error);
      });
  };

  const fetchOrganizationEmails = () => {
    authFetch(API_Root + "admin/get-organization-users", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ organization_id: 1 }), // change dynamically if needed
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const emails = data.users || [];
        setOrganizationEmails(emails);
      })
      .catch((error) => {
        console.error("Error fetching organization emails:", error);

        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const createNewChatSession = () => {
    const sessionName = "New Session"; // default session name

    authFetch(`${API_Root}session/create-demo-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_name: sessionName, email: userEmail }), // from useState
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const newSession = {
          id: data.session_id,
          chat_name: data.session_name,
        };

        // Update sessions array
        setSessions((prev) => [...prev, newSession]);

        // Show toast after successful update
        dispatch(
          toggleToast({
            show: true,
            type: "success",
            message: `Session "${sessionName}" created successfully!`,
          })
        );

        // Refresh session list
        fetchDemoSessions(userEmail);
      })
      .catch((error) => {
        console.error("Error creating new session:", error);

        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  // Auto-scroll to bottom on new messages
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  // Window resize tracking
  useEffect(() => {
    function onResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isDesktop = windowWidth >= 992;
  const isMobileNarrow = windowWidth < 600;

  const styles = {
    page: { height: "100vh", overflow: "hidden", background: "#F6F9F8" },

    topbar: {
      height: "60px",
      borderBottom: "1px solid #e5e5e5",
      background: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 16px",
    },

    leftSidebar: {
      width: 220,
      background: "#ffffff",
      flexShrink: 0, // 🔑 NEVER shrink
      minWidth: 220,
      borderRight: "1px solid #e5e5e5",
      padding: "20px 10px",
      display: "flex",
      flexDirection: "column",
    },

    rightPanel: {
      width: 330,
      background: "#ffffff",
      borderLeft: "1px solid #e5e5e5",
      padding: 20,
      overflowY: "auto",
    },

    // NEW MAIN CHAT AREA
    chatContainer: {
      flexGrow: 1,
      flexShrink: 1, // allow shrinking, but safely
      minWidth: 0, // 🔑 MOST IMPORTANT LINE
      display: "flex",
      flexDirection: "column",
      height: "100%",
      position: "relative",
      overflow: "hidden", // 🔑 prevents pushing sidebars
    },

    chatScrollArea: {
      flex: 1,
      minWidth: 0, // 🔑 REQUIRED
      overflowY: "auto",
      overflowX: "hidden", // 🔒 NO horizontal growth
      // padding: "20px",
      paddingBottum: "60px",
      marginBottom: 90,
    },

    nochatScrollArea: {
      flex: 1,
      // padding: "20px",
      paddingBottum: "60px",
      marginBottom: 90,
    },

    inputBarWrapper: {
      position: "absolute",
      bottom: 15,
      left: "50%",
      transform: "translateX(-50%)",
      width: isMobileNarrow ? "92%" : "70%",
    },

    inputBar: {
      background: "#ffffff",
      borderRadius: 30,
      border: "1px solid #dddddd",
      padding: 12,
      display: "flex",
      gap: 12,
      alignItems: "center",
      width: "113%",
    },

    floatingFilesBtn: {
      position: "fixed",
      right: 18,
      bottom: 18,
      zIndex: 1050,
      borderRadius: 30,
      boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
    },
  };

  const approvedFiles = [
    "29/1/b_1FINAL_HRD_MANUAL-APP…",
    "29/Appendix C_Social Baseline…",
    "29/Commitments Register_080…",
    "29/ESMP_05_WMP(1).docx",
    "29/ESMP_09a_OHSMP_tracke…",
    "29/ESMP_v1_CLEAN.docx",
    "29/ESMS_Manual_V1.docx",
    "29/ESIA 04_Redacted.pdf",
  ];

  const handleRenamClicked = () => {
    setrename(true);
  };

  const handleCancelRename = () => {
    setrename(false);
  };

  const handleConfirmRename = (e, id) => {
    e.preventDefault();
    if (!renamedSessionId.trim()) {
      alert("Session name cannot be empty.");
      return;
    }

    authFetch(`${API_Root}session/demo-rename-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: id,
        new_name: renamedSessionId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }
        dispatch(
          toggleToast({
            show: true,
            type: "success",
            message: "Session renamed successfully!",
          })
        );

        fetchDemoSessions(userEmail);
        setrename(false);

        // Optionally refresh sessions list here
      })
      .catch((error) => {
        console.error("Error renaming session:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const exportSession = (e, id) => {
    e.preventDefault();
    authFetch(`${API_Root}session/demo-export-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: id,
        email: userEmail, // from useState
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.blob(); // file blob
      })
      .then((blob) => {
        // Create a temporary downloadable file link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `session_${id}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error exporting session:", error);

        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const handleLogout = () => {
    doSignOut()
      .then(() => {
        localStorage.removeItem("isLoggedIn");
        history.push("/");
      })
      .catch(() => {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Logout failed",
          })
        );
      });
  };

  const handleBenchmarkFiles = (files) => {
    const fileArray = Array.from(files);

    if (
      fileArray.length + benchmarkLocalFiles.length + benchmarkKBFiles.length >
      5
    ) {
      alert("Maximum 5 files allowed");
      return;
    }

    setBenchmarkLocalFiles((prev) => [...prev, ...fileArray]);

    // ask user if they want to upload to KB
    setAskUploadKB(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleBenchmarkFiles(e.dataTransfer.files);
    }
  };

  const fetchUserSessions = async (email) => {
    try {
      const response = await fetch(
        API_Root + "private/private-chatbot-sessions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setSessions(data.sessions || []);
    } catch (error) {
      console.error("Error fetching user sessions:", error);
    }
  };

  const deleteSession = async (e, selectedSessionId) => {
    e.preventDefault();
    try {
      const response = await authFetch(
        API_Root + "session/delete-demo-session",
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: selectedSessionId }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      // Refresh sessions
      fetchDemoSessions(userEmail);
    } catch (error) {
      console.error("Error deleting session:", error);

      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Something went wrong",
        })
      );
    }
  };

  const handleMyEsra = () => {
    history.push("/chat");
  };

  const handleAdmin = () => {
    setShowAdminModal(true);
    fetchTeamStorageUsage();
  };

  const handleTeam = () => {
    setTeamMembersDialog(true);
  };

  const handleUpload = () => {};

  const handleProfile = () => {
    history.push("/profile");
  };

  const handelRequestTeam = () => {
    if (inviteTeamName.trim() === "") {
      dispatch(
        toggleToast({
          show: true,
          type: "warning",
          message: "Please enter a valid team name.",
        })
      );
      return;
    }
  };

  const handleInviteToTeam = (team) => {
    authFetch(API_Root + "team/get-team-members-by-name", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team_name: team }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setFullTeams(data.members || []);
      });
  };

  const handleInviteMember = async (team) => {
    const email = inviteEmail.trim();
    const role = inviteRole;
    const teamName = team;

    if (!email) return;

    const payload = {
      team_name: teamName,
      invites: [
        {
          email,
          role,
        },
      ],
    };

    try {
      const response = await authFetch(API_Root + "team/invite-team-members", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to invite member");
      }

      const data = await response.json();
      // Update state
      setFullTeams((prev) => [...prev, { email }]);
      setInviteEmail("");
      setInviteRole("User");
      setShowAddMemberForm(false);
    } catch (error) {
      console.error("Error inviting member:", error);
      // Optionally show toast here if you have one
    }
  };

  const removeTeamMember = async (email, team) => {
    try {
      const response = await authFetch(API_Root + "team/remove-team-member", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ team_name: team, email }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      await response.json();

      setFullTeams((prevState) => ({
        fullTeam: prevState.filter((member) => member.email !== email),
      }));
      setEditTeamId(null);
      fetchTeams(email);

      dispatch(
        toggleToast({
          show: true,
          type: "success",
          message: `${email} removed from the team.`,
        })
      );
    } catch (error) {
      console.error("Error removing team member:", error);
      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Something went wrong",
        })
      );
    }
  };

  const uploadFilesToKB = async () => {
    try {
      const formData = new FormData();

      benchmarkLocalFiles.forEach((file) => {
        formData.append("files", file);
      });

      await authFetch(`${API_Root}team/add-to-kb`, {
        method: "POST",
        body: formData,
      });

      setAskUploadKB(false);
    } catch (err) {
      console.error("KB Upload error", err);
    }
  };

  const startBenchmark = async () => {
    try {
      setShowBenchmarkModal(false);
      setBenchmarkRunning(true);

      const formData = new FormData();

      // Local files
      benchmarkLocalFiles.forEach((file) => {
        formData.append("files", file);
      });

      // KB files
      benchmarkKBFiles.forEach((name) => {
        formData.append("filenames", name);
      });

      formData.append("report_type", benchmarkStandard);
      formData.append("email", userEmail);

      const response = await authFetch(`${API_Root}chat/analyze-documents`, {
        method: "POST",
        body: formData,
      });

      const blob = await response.blob();

      const contentDisposition = response.headers.get("Content-Disposition");

      let filename = "benchmark-report.docx";

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );

        if (match && match[1]) {
          filename = match[1].replace(/['"]/g, "");
        }
      }

      const fileURL = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileURL;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(fileURL);

      setBenchmarkRunning(false);
    } catch (error) {
      console.error(error);
      setBenchmarkRunning(false);
    }
  };

  const removeLocalFile = (index) => {
    setBenchmarkLocalFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const removeKBFile = (filename) => {
    setBenchmarkKBFiles((prev) => prev.filter((f) => f !== filename));
  };

  const handleDeleteTeam = (teamName) => {
    authFetch(`${API_Root}team/delete-demo-team`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team_name: teamName }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        dispatch(
          toggleToast({
            show: true,
            type: "success",
            message: `Team "${teamName}" deleted successfully!`,
          })
        );
        // Remove the team from the state
        setFullTeams((prevState) => ({
          fullTeam: prevState.filter((team) => team !== teamName),
        }));
      })
      .catch((error) => {
        console.error("Error deleting team:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Something went wrong",
          })
        );
      });
  };

  const fetchFilesForApproval = async () => {
    try {
      const response = await authFetch(
        API_Root + "files/get-unapproved-files",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      setFilesForApproval(data.files || []);
    } catch (error) {
      console.error("Error fetching files for approval:", error);

      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Something went wrong",
        })
      );
    }
  };

  const approveFile = async (fileId) => {
    try {
      const response = await authFetch(API_Root + "files/approve-file", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: fileId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      await response.json();

      // Update state
      setFilesForApproval((prev) => prev.filter((file) => file.id !== fileId));

      dispatch(
        toggleToast({
          show: true,
          type: "success",
          message: "File approved successfully!",
        })
      );
    } catch (error) {
      console.error("Error approving file:", error);

      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Something went wrong",
        })
      );
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (!files || files.length === 0) return;

    const newFiles = Array.from(files).map((file) => ({
      file,
      status: "Pending",
      progress: 0,
    }));

    // Update UI state
    setSelectedFiles((prev) => [...prev, ...newFiles]);

    // Upload immediately using fresh files
    handleFileUpload(newFiles);
  };

  const handleFileUpload = async (filesToUpload) => {
    if (!filesToUpload || filesToUpload.length === 0) {
      dispatch(
        toggleToast({
          show: true,
          type: "warning",
          message: "Please select files for upload.",
        })
      );
      return;
    }

    // ✅ Upload started toast
    dispatch(
      toggleToast({
        show: true,
        type: "info",
        message: "File upload in progress...",
      })
    );

    // ---- Simulated Progress ----
    const intervalId = setInterval(() => {
      setSelectedFiles((prevFiles) =>
        prevFiles.map((fileObj) => {
          if (fileObj.progress < 99) {
            const increment = Math.floor(Math.random() * 5) + 1;

            return {
              ...fileObj,
              progress: Math.min(fileObj.progress + increment, 99),
            };
          }

          return fileObj;
        })
      );
    }, 500);

    const formData = new FormData();

    filesToUpload.forEach((f) => {
      formData.append("files", f.file);
    });

    formData.append("email", userEmail);

    try {
      const response = await authFetch(`${API_Root}files/demo-upload`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.error) throw new Error(data.error);

      clearInterval(intervalId);

      setSelectedFiles((prev) =>
        prev.map((fileObj) => ({
          ...fileObj,
          progress: 100,
        }))
      );

      setTimeout(() => {
        setSelectedFiles([]);

        // ✅ Success toast
        dispatch(
          toggleToast({
            show: true,
            type: "success",
            message: data.message,
          })
        );

        fetchDemoFiles(userEmail);
        fetchFilesForApproval();
      }, 500);
    } catch (error) {
      console.error("Error uploading files:", error);

      clearInterval(intervalId);

      // ❌ Error toast
      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Failed to upload files. Please try again.",
        })
      );
    }
  };

  const handleSyncFiles = () => {
    authFetch(`${API_Root}files/demo-sync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }

        // Save ingestionJobId in state AND localStorage
        setIngestionJobId(data.ingestionJobId);
        localStorage.setItem("ingestionJobId", data.ingestionJobId);

        dispatch(
          toggleToast({
            show: true,
            type: "success",
            message: `${data.message} (Job ID: ${data.ingestionJobId})`,
          })
        );
      })
      .catch((error) => {
        console.error("Error syncing files:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Failed to sync files. Please try again.",
          })
        );
      });
  };

  const handleCheckSyncStatus = () => {
    const ingestionJobId =
      localStorage.getItem("ingestionJobId") || stateIngestionJobId;

    if (!ingestionJobId) {
      dispatch(
        toggleToast({
          show: true,
          type: "warning",
          message: "No ingestion job ID found. Please sync files first.",
        })
      );
      return;
    }

    localStorage.setItem("syncing", "true");

    dispatch(
      toggleToast({
        show: true,
        type: "info",
        message: "Sync is in progress...",
      })
    );

    authFetch(`${API_Root}files/demo-check-sync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ingestionJobId,
        email: userEmail,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem("syncing", "false");

        if (data.error) {
          throw new Error(data.error);
        }
        dispatch(
          toggleToast({
            show: true,
            type: "info",
            message: `Ingestion job status: ${data.status}`,
          })
        );
      })
      .catch((error) => {
        localStorage.setItem("syncing", "false");
        console.error("Error checking sync status:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Failed to check sync status. Please try again.",
          })
        );
      });
  };

  const handleDeleteAllFiles = async () => {
    if (
      !window.confirm(
        "Are you sure you want to delete all files? This action cannot be undone."
      )
    ) {
      return;
    }

    try {
      // DELETE ALL FILES
      const deleteResponse = await authFetch(
        `${API_Root}files/demo-delete-files-all`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: userEmail }),
        }
      );

      if (!deleteResponse.ok) {
        throw new Error(`HTTP error! Status: ${deleteResponse.status}`);
      }

      const deleteData = await deleteResponse.json();
      dispatch(
        toggleToast({
          show: true,
          type: "success",
          message: deleteData.message,
        })
      );

      // refresh file list
      fetchDemoFiles(userEmail);

      // START SYNC
      const syncResponse = await authFetch(`${API_Root}files/demo-sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: userEmail }),
      });

      if (!syncResponse.ok) {
        throw new Error(
          `HTTP error during sync! Status: ${syncResponse.status}`
        );
      }

      const syncData = await syncResponse.json();

      if (syncData.ingestionJobId) {
        localStorage.setItem("ingestionJobId", syncData.ingestionJobId);
        dispatch(
          toggleToast({
            show: true,
            type: "info",
            message: "Sync started successfully. Ingestion job ID stored.",
          })
        );
      } else {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Sync started but no ingestion job ID was returned.",
          })
        );
      }
    } catch (error) {
      console.error("Error deleting files:", error);
      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Failed to delete all files",
        })
      );
    }
  };

  const handleDeleteFile = async (filename) => {
    try {
      const response = await authFetch(`${API_Root}files/delete-demo-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ filename }),
      });

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error);
      }

      // Update state
      setFilenames((prev) => prev.filter((file) => file !== filename));
      dispatch(
        toggleToast({
          show: true,
          type: "success",
          message: `File "${filename}" deleted successfully.`,
        })
      );
    } catch (error) {
      console.error("Error deleting file:", error);
      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Failed to delete file. Please try again.",
        })
      );
    }
  };

  const fetchTeamStorageUsage = async () => {
    if (!selectedTeamId) return; // same logic as before

    try {
      const response = await authFetch(
        `${API_Root}team/get-team-storage-usage`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ team_id: selectedTeamId }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.error) {
        setTeamStorageUsage(data.usedBytes);
      }
    } catch (error) {
      console.error("Error fetching storage usage:", error);
    }
  };

  const handleCheckboxChange = (event, filename) => {
    setSelectedApprovedFiles((prev) => {
      if (event.target.checked) {
        // Add file
        return [...prev, filename];
      } else {
        // Remove file
        return prev.filter((f) => f !== filename);
      }
    });
  };

  const getChatResponse = async () => {
    // Early return if user did not type anything
    if (
      !message.trim() &&
      !(
        responseType === "Quick Bench Marking" &&
        selectedApprovedFiles.length > 0
      )
    ) {
      return;
    }

    // ✅ FIXED: always send selectedApprovedFiles as array of strings
    const formattedApprovedFiles = selectedApprovedFiles.map((file) =>
      typeof file === "string" ? file : file.filename
    );

    // =========================
    // ========= CANVAS ========
    // =========================
    if (responseType === "Canvas") {
      if (!message.trim()) return;

      setIsLoading(true);

      const payload = {
        prompt: message,
        modelId: selectedModel,
        session_id: newSessionId.id,
        email: userEmail,
        responseType: "Text",
        anonymous,
        ...(formattedApprovedFiles.length > 0 && {
          selectedApprovedFiles: formattedApprovedFiles,
        }),
      };

      try {
        const response = await authFetch(`${API_Root}chat/canvas`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (data.error) throw new Error(data.error);

        setNewMessage((prev) => [
          ...(Array.isArray(prev) ? prev : []),
          { sender: "You", text: message, type: "sent" },
        ]);

        setCanvasMessage((prev) => {
          const safePrev = Array.isArray(prev) ? prev : [];
          return [
            ...safePrev,
            {
              id: data.message_id,
              question: message,
              answer: data.response,
              citations: data.citations || [],
            },
          ];
        });

        setMessage("");
      } catch (err) {
        console.error("Canvas error:", err);
      } finally {
        setIsLoading(false);
      }

      return;
    }

    // ==========================================
    // ===== QUICK BENCHMARK CASE ===============
    // ==========================================
    if (
      responseType === "Quick Bench Marking" &&
      formattedApprovedFiles.length > 0
    ) {
      setIsLoading(true);

      try {
        const queryString = formattedApprovedFiles
          .map((file) => `file_name=${encodeURIComponent(file)}`)
          .join("&");

        const apiUrl = `${API_Root}chat/analyze-documents?${queryString}`;

        const response = await authFetch(apiUrl, { method: "GET" });
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const fileURL = window.URL.createObjectURL(blob);
        window.open(fileURL, "_blank");

        const analyzedFilesText =
          formattedApprovedFiles.length === 1
            ? `Analyzed file: ${formattedApprovedFiles[0]}`
            : `Analyzed ${
                formattedApprovedFiles.length
              } files:\n${formattedApprovedFiles.join(", ")}`;

        setNewMessage((prev) => [
          ...prev,
          { sender: "You", text: analyzedFilesText, type: "sent" },
          {
            sender: "Bot",
            text: "Benchmark analysis completed successfully. File downloaded/opened.",
            type: "response",
          },
        ]);

        setMessage("");
        setIsLoading(false);
      } catch (error) {
        console.error("Error calling /chat/analyze-documents:", error);
        setIsLoading(false);
      }

      return;
    }

    // ==========================================
    // ========= DEFAULT CHAT FLOW ==============
    // ==========================================
    setIsLoading(true);

    const payload = {
      prompt: message,
      modelId: selectedModel,
      session_id: newSessionId.id,
      email: userEmail,
      responseType,
      anonymous,
    };

    if (formattedApprovedFiles.length > 0) {
      payload.selectedApprovedFiles = formattedApprovedFiles;
    }

    try {
      const response = await authFetch(`${API_Root}chat/demo-chat-bedrock`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.error) throw new Error(data.error);

      const hasFiles =
        formattedApprovedFiles && formattedApprovedFiles.length > 0;

      const citationText =
        data.citations && data.citations.length > 0
          ? data.citations
              .map((c) => `📄 ${c.filename}\n\n${c.content}`)
              .join("\n\n--------------------\n\n")
          : "";

      const botMessage = {
        id: data.message_id,
        sender: "Bot",
        text: data.response,
        type: "response",
      };

      setNewMessage((prev) => {
        const safePrev = Array.isArray(prev) ? prev : [];
        return [
          ...safePrev,
          { sender: "You", text: message, type: "sent" },
          botMessage,
        ];
      });

      setMessage("");
      setIsLoading(false);
    } catch (error) {
      console.error("Error interacting with Amazon Bedrock:", error);
      setIsLoading(false);
    }
  };

  const toggleVoiceInputForMessage = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Sorry, your browser does not support speech recognition.");
      return;
    }

    // Stop listening if already active
    if (recognitionRef.current && isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
      return;
    }

    // Auto-use browser/system language
    const lang = navigator.language || "en-IN";

    const recognition = new SpeechRecognition();
    recognition.lang = lang;
    recognition.interimResults = true;
    recognition.continuous = true;

    recognitionRef.current = recognition;

    let finalTranscript = message || "";

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onresult = (event) => {
      let interimTranscript = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript.trim();

        if (event.results[i].isFinal) {
          finalTranscript += " " + transcript;
        } else {
          interimTranscript += " " + transcript;
        }
      }

      const combined = (finalTranscript + interimTranscript).trim();
      setMessage(combined);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      if (event.error === "not-allowed") {
        alert("Microphone access was denied. Please allow mic permissions.");
      }
      setIsListening(false);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.start();
  };

  const switchTeam = (team_id) => {
    authFetch(`${API_Root}team/demo-switch-team`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        team_id,
        email: userEmail, // from useState
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        dispatch(
          toggleToast({
            show: true,
            type: "success",
            message: "Switched team successfully!",
          })
        );

        // Reload app to reflect new team context
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error switching team:", error);
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Failed to switch team",
          })
        );
      });
  };

  const formatESAPToMarkdown = (data) => {
    if (!data?.grouped_results) return "No data available";

    const groups = data.grouped_results;

    let markdown = `# ESAP Compliance Report\n\n`;
    markdown += `**Total Actions:** ${data?.total_actions || 0}\n\n`;

    Object.keys(groups).forEach((group) => {
      const items = groups[group];

      if (!items || items.length === 0) return;

      markdown += `## ${group}\n\n`;

      items.forEach((item, index) => {
        markdown += `### ${index + 1}. ${item.status}\n\n`;

        markdown += `**Action:**\n${item.esap_action}\n\n`;

        markdown += `**Justification:**\n${item.justification}\n\n`;

        markdown += `---\n\n`;
      });
    });

    return markdown;
  };

  const startESAPCompliance = async () => {
    // ✅ STEP VALIDATION
    if (esapLocalFiles.length === 0) {
      setEsapError("Step 1: Please upload at least one local ESAP file.");
      return;
    }

    if (esapKBFiles.length === 0) {
      setEsapError(
        "Step 2: Please select at least one file from Knowledge Base."
      );
      return;
    }

    setEsapError(""); // clear error

    try {
      setEsapRunning(true);
      setShowESAPModal(false);

      const formData = new FormData();

      formData.append("email", userEmail);

      esapLocalFiles.forEach((file) => {
        formData.append("files", file);
      });

      esapKBFiles.forEach((name) => {
        formData.append("kb_files", name);
      });

      const response = await authFetch(`${API_Root}files/esap-review`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: data?.message || data?.error || "Failed to extract files",
          })
        );
        setEsapLocalFiles([]);
        setEsapKBFiles([]);

        return;
      }

      // ✅ Transform API → Markdown
      const formattedResponse = formatESAPToMarkdown(data);

      // ✅ Push into canvas
      setCanvasMessage((prev) => [
        ...prev,
        {
          type: "esap",
          answer: formattedResponse,
          data: data,
        },
      ]);

      setEsapRunning(false);
      setEsapLocalFiles([]);
      setEsapKBFiles([]);
    } catch (error) {
      console.error(error);
      setEsapError(error);
      setShowESAPModal(false);
      setEsapRunning(false);
      setEsapLocalFiles([]);
      setEsapKBFiles([]);
    }
  };

  const uploadESAPFilesToKB = async () => {
    try {
      const formData = new FormData();

      esapLocalFiles.forEach((file) => {
        formData.append("files", file);
      });

      formData.append("team_id", selectedTeamId);

      const response = await authFetch(
        `${API_Root}files/upload-to-kb`, // 🔁 replace with your actual API
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      // optional UX improvements
      setEsapAskUploadKB(false);
    } catch (error) {
      console.error("Error uploading ESAP files to KB:", error);
    }
  };

  const handleKBFileSelect = (file) => {
    setBenchmarkKBFiles((prev) => {
      const exists = prev.find((f) => f === file?.filename);

      if (exists) {
        return prev.filter((f) => f !== file?.filename);
      } else {
        if (prev.length >= 5) return prev; // max 5 limit
        return [...prev, file?.filename];
      }
    });
  };

  const handleESDDKBFileSelect = (file) => {
    setEsddKBFiles((prev) => {
      const exists = prev.includes(file?.filename);

      if (exists) {
        return prev.filter((f) => f !== file?.filename);
      } else {
        if (prev.length >= 5) return prev; // max 5
        return [...prev, file?.filename];
      }
    });
  };

  const handleESAPKBFileSelect = (file) => {
    setEsapKBFiles((prev) => {
      const exists = prev.includes(file?.filename);

      if (exists) {
        return prev.filter((f) => f !== file?.filename);
      } else {
        if (prev.length >= 5) return prev; // max 5
        return [...prev, file?.filename];
      }
    });
  };

  const startESDD = async () => {
    // ✅ STEP VALIDATION
    if (esddLocalFiles.length === 0) {
      setEsddError("Step 1: Please upload at least one local file.");
      return;
    }

    if (esddKBFiles.length === 0) {
      setEsddError(
        "Step 2: Please select at least one file from Knowledge Base."
      );
      return;
    }

    if (!esddStandard) {
      setEsddError("Please select a standard (IFC / EBRD).");
      return;
    }

    setEsddError("");

    try {
      if (!esddStandard) {
        alert("Please select a standard (IFC / EBRD)");
        return;
      }

      if (esddLocalFiles.length === 0 && esddKBFiles.length === 0) {
        alert("Please select or upload at least one file");
        return;
      }

      setShowESDDModal(false);
      setEsddRunning(true);

      const formData = new FormData();

      // ✅ LOCAL FILES (binary)
      esddLocalFiles.forEach((file) => {
        formData.append("files", file); // multiple allowed
      });

      // ✅ KB FILES (names only)
      esddKBFiles.forEach((name) => {
        formData.append("files", name); // multiple allowed
      });

      // ✅ REQUIRED FIELDS
      formData.append("report_type", esddStandard); // "ifc" | "ebrd"
      formData.append("username", userEmail); // 🔁 make sure this exists

      const response = await authFetch(`${API_Root}files/due-diligence`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: data?.message || data?.error || "Failed to extract files",
          })
        );

        setEsddStandard("ifc");
        setEsddKBFiles([]);
        setEsddLocalFiles([]);

        return;
      }
      // ✅ Push into canvas
      setCanvasMessage((prev) => [
        ...prev,
        {
          type: "esdd",
          answer: data.report,
        },
      ]);

      setEsddRunning(false);
    } catch (err) {
      console.error("ESDD ERROR:", err);
    } finally {
      setEsddRunning(false);
      setEsddKBFiles([]);
      setEsddLocalFiles([]);
    }
  };

  const uploadESDDFilesToKB = async () => {
    const formData = new FormData();

    esddLocalFiles.forEach((file) => {
      formData.append("files", file);
    });

    formData.append("team_id", selectedTeamId);

    await authFetch(`${API_Root}files/upload-to-kb`, {
      method: "POST",
      body: formData,
    });

    setEsddAskUploadKB(false);
  };

  const handleUploadToKB = () => {
    // upload logic
    handleYesUploadAndDownload(); // optional: download after upload
  };

  const handleYesUploadAndDownload = async () => {
    try {
      if (!canvasRef.current) return;

      // 👉 1. Generate DOC from canvas
      const htmlContent = canvasRef.current.innerHTML;

      const docHtml = `
        <html xmlns="http://www.w3.org/TR/REC-html40">
          <body>${htmlContent}</body>
        </html>
      `;

      const blob = new Blob([docHtml], {
        type: "application/msword",
      });

      // 👉 Create a File (IMPORTANT for FormData upload)
      const file = new File([blob], "canvas-report.doc", {
        type: "application/msword",
      });

      // 👉 2. Upload to KB
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "report_type",
        responseType == "esap" ? "esap" : "due-diligence"
      ); // or username variable
      formData.append("team_id", selectedTeamId);

      await authFetch(`${API_Root}/files/add-report-to-kb`, {
        method: "POST",
        body: formData,
      });

      // 👉 3. Download locally
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "canvas-report.doc";
      link.click();

      URL.revokeObjectURL(url);

      // 👉 Close modal
      setOpenModule(false);
    } catch (error) {
      console.error("Upload/Download error:", error);
    }
  };

  const categories = [
    "all",
    ...new Set(
      filenames.map((file) => file.metadata?.category).filter(Boolean)
    ),
  ];

  const subcategories = [
    "all",
    ...new Set(
      filenames
        .filter((file) =>
          selectedCategory === "all"
            ? true
            : file.metadata?.category === selectedCategory
        )
        .map((file) => file.metadata?.subcategory)
        .filter(Boolean)
    ),
  ];

  const filteredFiless = filenames.filter((file) => {
    const categoryMatch =
      selectedCategory === "all" ||
      file.metadata?.category === selectedCategory;

    const subcategoryMatch =
      selectedSubcategory === "all" ||
      file.metadata?.subcategory === selectedSubcategory;

    return categoryMatch && subcategoryMatch;
  });

  const cleanTextForSpeech = (text) => {
    return text
      .replace(/[#*`>-]/g, "")
      .replace(/\n/g, ". ")
      .replace(/\s+/g, " ")
      .trim();
  };

  const speakText = (text) => {
    const cleaned = cleanTextForSpeech(text);

    window.speechSynthesis.cancel();

    const chunks = cleaned.match(/.{1,200}(\s|$)/g) || [cleaned];

    let index = 0;

    const speakNext = () => {
      if (index >= chunks.length) return;

      const utterance = new SpeechSynthesisUtterance(chunks[index]);

      utterance.onend = () => {
        index++;
        speakNext();
      };

      window.speechSynthesis.speak(utterance);
    };

    speakNext();
  };

  const stopSpeech = () => {
    window.speechSynthesis.cancel();
  };

  return (
    <div style={styles.page}>
      {/* TOP BAR */}
      <div style={styles.topbar}>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link p-0 me-2"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle sidebar"
          >
            <i className="bi bi-list" style={{ fontSize: 22 }}></i>
          </button>

          <span className="logo-text" role="heading">
            <Link to="/" style={{ color: "#3E826D" }}>
              privatESRA
            </Link>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <button
            className="me-2"
            onClick={handleLogout}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              color: hover ? "#dc3545" : "#000",
              transform: hover ? "scale(1.05)" : "scale(1)",
              transition: "all 0.3s ease",
              fontSize: "small",
            }}
          >
            Logout
          </button>

          <select
            className="form-select form-select-sm me-2"
            style={{ width: 180 }}
            value={selectedTeamId}
            onChange={(e) => {
              const selectedId = e.target.value;
              setSelectedTeamId(selectedId);

              if (selectedId !== "") {
                switchTeam(selectedId);
              }
            }}
          >
            <option value="" disabled>
              Switch Teams
            </option>

            {switchTeams?.map((team) => (
              <option key={team.id} value={team.id}>
                {team.team_name}
              </option>
            ))}
          </select>

          <select
            className="form-select form-select-sm"
            style={{ width: 150 }}
            value={selectedModel}
            onChange={(e) => setSelectedModel(e.target.value)}
          >
            <option value="llama38b">Llama 3 8B</option>
            <option value="llama370b">Llama 3 70B</option>
            <option value="Claude4_Sonnet">Claude 4</option>
            <option value="Claude3.5_Haiku">Claude3.5_Haiku</option>
          </select>
        </div>
      </div>

      <div
        className="d-flex"
        style={{
          height: "calc(100vh - 60px)",
          width: "100%",
          overflow: "hidden", // 🔑 prevents layout push
        }}
      >
        {/* LEFT SIDEBAR (desktop) */}
        {isDesktop ? (
          <div
            style={{
              ...styles.leftSidebar,
              width: sidebarOpen ? 260 : 0,
              minWidth: sidebarOpen ? 260 : 0,
              transition: "all 0.3s ease",
              overflow: "hidden",
              display: sidebarOpen ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            <Button
              className="w-100 mb-3"
              style={{
                background: "#0E5E3D",
                borderRadius: 8,
                border: "none",
                height: 45,
              }}
              onClick={createNewChatSession}
            >
              New Chat
            </Button>

            {/* ⭐ SCROLLABLE SESSIONS LIST */}
            <div
              style={{
                flexGrow: 1,
                overflowY: "auto",
                paddingRight: 4,
              }}
            >
              {sessions?.map((name, idx) => (
                <div
                  key={idx}
                  className="d-flex justify-content-between align-items-center px-2 py-2"
                  style={{
                    fontSize: 14,
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                  onClick={(e) => selectChatSession(e, name?.id)}
                >
                  <div>
                    <i className="bi bi-chat-left-text"></i> &nbsp;
                    {name?.session_name}
                  </div>
                  <Dropdown
                    align="end"
                    drop="end"
                    autoClose={false} // ⭐ prevents dropdown from closing
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Dropdown.Toggle
                      variant="link"
                      bsPrefix="p-0 m-0 border-0 bg-transparent"
                      style={{ color: "black" }}
                    >
                      <i className="bi bi-three-dots-vertical"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      popperConfig={{
                        strategy: "fixed",
                      }}
                    >
                      {rename ? (
                        <>
                          <input
                            type="text"
                            className="form-control m-2"
                            value={renamedSessionId}
                            onClick={(e) => e.stopPropagation()} // ⭐ prevent closing
                            onChange={(e) =>
                              setRenamedSessionId(e.target.value)
                            }
                            style={{ width: "auto" }}
                            autoFocus
                          />

                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault(); // ⭐ don't close
                              e.stopPropagation(); // ⭐ don't close
                              handleConfirmRename(e, name?.id);
                            }}
                          >
                            <i className="bi bi-check2 me-2"></i> Confirm rename
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleCancelRename();
                            }}
                          >
                            <i className="bi bi-x-lg me-2"></i> Cancel
                          </Dropdown.Item>
                        </>
                      ) : (
                        <>
                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleRenamClicked();
                            }}
                          >
                            <i className="bi bi-pencil me-2"></i> Rename
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              exportSession(e, name?.id);
                            }}
                          >
                            <i className="bi bi-box-arrow-up me-2"></i> Export
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={(e) => deleteSession(e, name?.id)}
                          >
                            <i className="bi bi-trash me-2"></i> Delete
                          </Dropdown.Item>
                        </>
                      )}

                      <Dropdown.Divider />

                      <Dropdown.Item onClick={() => alert("Close clicked")}>
                        <i className="bi bi-x-lg me-2"></i> Close
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ))}
            </div>

            {/* ⭐ FIXED BOTTOM SECTION */}
            <div style={{ flexShrink: 0, marginTop: "auto" }}>
              <div className="px-2 py-2">
                <div style={{ fontSize: 14, fontWeight: 600 }}>
                  {firstName && lastName
                    ? `${firstName} ${lastName}`
                    : "Loading.."}
                </div>
              </div>
              <input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              {[
                {
                  icon: "bi-speedometer2",
                  label: "myESRA",
                  onClick: handleMyEsra,
                },
                {
                  icon: "bi-person-gear",
                  label: "Command Centre",
                  onClick: handleAdmin,
                },
                { icon: "bi-people", label: "Team", onClick: handleTeam },

                // ✅ FIXED — Trigger file chooser
                {
                  icon: "bi-upload",
                  label: "Upload Files",
                  onClick: () => {
                    if (fileInputRef.current) {
                      fileInputRef.current.value = ""; // important reset
                      fileInputRef.current.click();
                    }
                  },
                },

                {
                  icon: "bi-person-circle",
                  label: "Profile",
                  onClick: handleProfile,
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center px-2 py-2"
                  style={{ cursor: "pointer" }}
                  onClick={item.onClick}
                >
                  <i className={`bi ${item.icon}`}></i>
                  <span className="ms-2">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Offcanvas show={sidebarOpen} onHide={() => setSidebarOpen(false)}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>privatESRA</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Button
                className="w-100 mb-3"
                style={{
                  background: "#0E5E3D",
                  borderRadius: 8,
                  border: "none",
                  height: 45,
                }}
                onClick={createNewChatSession}
              >
                New Chat
              </Button>

              {sessions?.map((name, idx) => (
                <div
                  key={idx}
                  className="d-flex justify-content-between align-items-center px-2 py-2"
                  style={{ fontSize: 14, borderRadius: 6, cursor: "pointer" }}
                  onClick={(e) => selectChatSession(e, name?.id)}
                >
                  <div>
                    <i className="bi bi-chat-left-text"></i> &nbsp;{" "}
                    {name?.session_name}
                  </div>
                  <i className="bi bi-three-dots-vertical"></i>
                  <Dropdown
                    align="end"
                    drop="end"
                    autoClose={false} // ⭐ prevents dropdown from closing
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Dropdown.Toggle
                      variant="link"
                      bsPrefix="p-0 m-0 border-0 bg-transparent"
                      style={{ color: "black" }}
                    >
                      <i className="bi bi-three-dots-vertical"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      popperConfig={{
                        strategy: "fixed",
                      }}
                    >
                      {rename ? (
                        <>
                          <input
                            type="text"
                            className="form-control m-2"
                            value={renamedSessionId}
                            onClick={(e) => e.stopPropagation()} // ⭐ prevent closing
                            onChange={(e) =>
                              setRenamedSessionId(e.target.value)
                            }
                            style={{ width: "auto" }}
                            autoFocus
                          />

                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault(); // ⭐ don't close
                              e.stopPropagation(); // ⭐ don't close
                              handleConfirmRename(e, name?.id);
                            }}
                          >
                            <i className="bi bi-check2 me-2"></i> Confirm rename
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleCancelRename();
                            }}
                          >
                            <i className="bi bi-x-lg me-2"></i> Cancel
                          </Dropdown.Item>
                        </>
                      ) : (
                        <>
                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleRenamClicked();
                            }}
                          >
                            <i className="bi bi-pencil me-2"></i> Rename
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={(e) => {
                              e.preventDefault();
                              exportSession(e, name?.id);
                            }}
                          >
                            <i className="bi bi-box-arrow-up me-2"></i> Export
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={(e) => deleteSession(e, name?.id)}
                          >
                            <i className="bi bi-trash me-2"></i> Delete
                          </Dropdown.Item>
                        </>
                      )}

                      <Dropdown.Divider />

                      <Dropdown.Item onClick={() => alert("Close clicked")}>
                        <i className="bi bi-x-lg me-2"></i> Close
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ))}
              <div style={{ marginTop: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>
                  {firstName && lastName
                    ? `${firstName} ${lastName}`
                    : "Loading.."}
                </div>
                <div className="mt-2">
                  <input
                    type="file"
                    multiple
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  {[
                    {
                      icon: "bi-speedometer2",
                      label: "myESRA",
                      onClick: handleMyEsra,
                    },
                    {
                      icon: "bi-person-gear",
                      label: "Command Centre",
                      onClick: handleAdmin,
                    },
                    { icon: "bi-people", label: "Team", onClick: handleTeam },

                    // ✅ FIXED — Trigger file chooser
                    {
                      icon: "bi-upload",
                      label: "Upload Files",
                      onClick: () => {
                        if (fileInputRef.current) {
                          fileInputRef.current.value = ""; // important reset
                          fileInputRef.current.click();
                        }
                      },
                    },

                    {
                      icon: "bi-person-circle",
                      label: "Profile",
                      onClick: handleProfile,
                    },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center px-2 py-2"
                      style={{ cursor: "pointer" }}
                      onClick={item.onClick}
                    >
                      <i className={`bi ${item.icon}`}></i>
                      <span className="ms-2">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        )}

        {/* MAIN CHAT AREA (REPLACES WELCOME UI) */}
        <div
          style={{
            display: "flex",
            height: "100%",
            width: "100%",
            overflow: "hidden",
          }}
        >
          {/* ================= LEFT : CHAT ================= */}
          <div
            style={{
              ...styles.chatContainer,
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* CHAT SCROLL AREA */}
            <div
              style={
                newMessage?.length === 0
                  ? styles.nochatScrollArea
                  : styles.chatScrollArea
              }
            >
              {newMessage?.length === 0 ? (
                <div className="welcome-message">
                  <div className="welcome-logo" />
                  <span role="heading">
                    <h1>Welcome to privatESRA</h1>
                  </span>
                  <div className="sample-prompts-container">
                    <ol>
                      <li>Upload files to your private knowledge base</li>
                      <li>Resolve errors, if any, to complete upload</li>
                      <li>
                        Ask the privatESRA questions about the knowledge base
                      </li>
                      <li>Delete files & conversation history</li>
                    </ol>
                  </div>
                </div>
              ) : (
                <>
                  {newMessage?.map((msg, i) => (
                    <div
                      key={i}
                      className="mb-3 d-flex"
                      style={{
                        justifyContent:
                          msg.type === "sent" ? "flex-start" : "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      {/* USER IMAGE */}
                      {msg.type === "sent" && (
                        <img
                          src={userProfileImage}
                          alt="User"
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            marginRight: 8,
                          }}
                        />
                      )}

                      {/* MESSAGE BUBBLE */}
                      <div
                        style={{
                          maxWidth: "70%",
                          padding: "10px 14px",
                          borderRadius: 14,
                          background:
                            msg.type === "sent" ? "#0E5E3D" : "#E8F2EE",
                          color: msg.type === "sent" ? "white" : "black",
                          fontSize: 15,
                        }}
                      >
                        <div>{msg.text}</div>

                        {msg.type === "response" && (
                          <div
                            style={{
                              marginTop: "8px",
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "6px",
                              marginBottom:
                                i === newMessage.length - 1 ? "100px" : "0px",
                            }}
                          >
                            <button
                              className="btn btn-sm"
                              style={{
                                background: "#fff",
                                color: "black",
                                border: "1px solid #d1d5db",
                                borderRadius: "20px",
                                padding: "2px 10px",
                              }}
                              onClick={() => speakText(msg.text)}
                              title="Listen to response"
                            >
                              <i className="bi bi-volume-up-fill"></i>
                            </button>

                            <button
                              className="btn btn-sm"
                              style={{
                                background: "#fff",
                                color: "black",
                                border: "1px solid #d1d5db",
                                borderRadius: "20px",
                                padding: "2px 10px",
                              }}
                              onClick={stopSpeech}
                              title="Stop"
                            >
                              <i className="bi bi-stop-fill"></i>
                            </button>
                          </div>
                        )}
                      </div>

                      {/* APP LOGO */}
                      {msg.type === "response" && (
                        <img
                          src={yourLogoImage}
                          alt="Logo"
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            marginLeft: 8,
                            ...(i === newMessage.length - 1 && {
                              marginBottom: 100,
                            }),
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <div ref={chatEndRef}></div>
                </>
              )}
            </div>

            {/* ================= INPUT BAR ================= */}
            <div style={styles.inputBarWrapper}>
              <div
                style={{
                  ...styles.inputBar,
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                {/* Dropdown 1 */}
                <select
                  className="form-select"
                  style={{ width: 137 }}
                  value={anonymous ? "anonymous" : "show"}
                  disabled={responseType === "Quick Bench Marking"}
                  onChange={(e) => setAnonymous(e.target.value === "anonymous")}
                >
                  <option value="show">Show Name</option>
                  <option value="anonymous">Anonymous</option>
                </select>

                <button
                  className="btn"
                  style={{
                    background: "#0E5E3D",
                    color: "white",
                    borderRadius: 8,
                    height: 45,
                    padding: "0 15px",
                  }}
                  onClick={() => {
                    setShowTools(true);
                    setMinimizedTools(false);
                  }}
                >
                  +
                </button>

                {/* Textarea */}
                <textarea
                  className="form-control"
                  placeholder="Type a message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  style={{
                    flex: 1,
                    minHeight: 45,
                    maxHeight: 120,
                    resize: "none",
                    paddingTop: 10,
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      getChatResponse();
                    }
                  }}
                  disabled={responseType === "Quick Bench Marking"}
                />

                {/* Mic */}
                <button
                  className="btn"
                  style={{
                    background: "#0E5E3D",
                    width: 45,
                    height: 45,
                    borderRadius: "50%",
                  }}
                  onClick={toggleVoiceInputForMessage}
                >
                  <i className="bi bi-mic text-white"></i>
                </button>

                {/* Send */}
                <button
                  className="btn"
                  style={{
                    background: "#0E5E3D",
                    width: 45,
                    height: 45,
                    borderRadius: "50%",
                  }}
                  onClick={() => !isLoading && getChatResponse()}
                  disabled={isLoading}
                >
                  <i
                    className={`bi ${
                      isLoading
                        ? "bi-arrow-repeat rotating"
                        : "bi-arrow-up-short"
                    } text-white`}
                  ></i>
                </button>
              </div>
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: "#6B7280",
                  textAlign: "center",
                  background: "#F9FAFB",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  padding: "8px 12px",
                }}
              >
                <strong>Note:</strong> Responses are generated by an AI
                assistant and must be verified by an E&amp;S expert.
              </div>
            </div>
          </div>

          {/* ================= RIGHT : CANVAS ================= */}
          {["Canvas", "esap", "esdd"].includes(responseType) &&
            canvasMessage?.length > 0 && (
              <div
                style={{
                  width: 346,
                  minWidth: 346,
                  borderLeft: "1px solid #ddd",
                  background: "#f5f7fb",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    padding: "10px 12px",
                    borderBottom: "1px solid #ddd",
                    background: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <strong>Canvas</strong>
                  <i
                    className="bi bi-x-lg"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setResponseType("Text");
                      setCanvasMessage([]);
                    }}
                  ></i>
                </div>

                {/* Body */}
                <div ref={canvasRef} style={{ flexGrow: 1, overflowY: "auto" }}>
                  <AppCanvas
                    responseType={responseType}
                    canvasMessage={canvasMessage}
                    setOpenModule={setOpenModule}
                  />
                </div>
              </div>
            )}
        </div>

        {/* RIGHT PANEL (Desktop) */}
        {isDesktop ? (
          <div
            style={{
              ...styles.rightPanel,
              width: isRightPanelCollapsed ? 48 : 300,
              minWidth: isRightPanelCollapsed ? 48 : 300, // 🔑
              flexShrink: 0, // 🔑
              transition: "width 0.25s ease",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* HEADER (FIXED) */}
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ flexShrink: 0 }}
            >
              {!isRightPanelCollapsed && (
                <div style={{ fontSize: 12, color: "#777" }}>
                  Last Synced:{" "}
                  {lastSynced ? new Date(lastSynced).toLocaleString() : "N/A"}
                </div>
              )}

              <div className="d-flex align-items-center gap-2">
                {!isRightPanelCollapsed && (
                  <i
                    className="bi bi-arrow-repeat"
                    style={{ cursor: "pointer" }}
                    title="Refresh"
                    onClick={() => {
                      fetchDemoFiles(userEmail);
                      fetchFilesForApproval();
                      fetchTeamInfo(userEmail);
                      handleSyncFiles();
                    }}
                  ></i>
                )}

                <i
                  className={`bi ${
                    isRightPanelCollapsed
                      ? "bi-chevron-left"
                      : "bi-chevron-right"
                  }`}
                  style={{ cursor: "pointer", fontSize: 18 }}
                  title={isRightPanelCollapsed ? "Expand" : "Collapse"}
                  onClick={() => setIsRightPanelCollapsed((prev) => !prev)}
                ></i>
              </div>
            </div>

            {/* SCROLLABLE CONTENT */}
            {!isRightPanelCollapsed && (
              <div
                style={{
                  flexGrow: 1,
                  overflowY: "auto",
                  marginTop: 12,
                  paddingRight: 4,
                }}
              >
                <h6 className="fw-bold">Filters</h6>

                {/* CATEGORY */}
                <select
                  className="form-select mb-2"
                  value={selectedCategory}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value);
                    setSelectedSubcategory("all");
                  }}
                >
                  {categories.map((category) => (
                    <option key={category} value={category}>
                      {category === "all" ? "All Categories" : category}
                    </option>
                  ))}
                </select>

                {/* SUBCATEGORY */}
                <select
                  className="form-select mb-3"
                  value={selectedSubcategory}
                  onChange={(e) => setSelectedSubcategory(e.target.value)}
                  disabled={!selectedCategory}
                >
                  {subcategories.map((subcategory) => (
                    <option key={subcategory} value={subcategory}>
                      {subcategory === "all"
                        ? "All Subcategories"
                        : subcategory}
                    </option>
                  ))}
                </select>

                {/* CLEAR BUTTON */}
                <button
                  className="btn btn-sm btn-outline-secondary w-100 mb-3"
                  onClick={() => {
                    setSelectedCategory("");
                    setSelectedSubcategory("");
                  }}
                >
                  Clear Filters
                </button>

                <h6 className="fw-bold">Approved Files</h6>

                {filteredFiles?.map((file, idx) => (
                  <div
                    key={idx}
                    className="d-flex align-items-center px-2 py-2 my-1"
                    style={{
                      fontSize: 14,
                      border: "1px solid #ddd",
                      borderRadius: 6,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(e, file)}
                      checked={selectedApprovedFiles.includes(file)}
                      className="me-2"
                    />
                    <span>{file?.filename}</span>
                  </div>
                ))}

                {/* UNAPPROVED FILES — NOW ALWAYS REACHABLE */}
                <h6 className="mt-4 fw-bold">Unapproved Files</h6>
                {filesForApproval?.length > 0 ? (
                  <>
                    {filesForApproval?.map((file, idx) => (
                      <div
                        key={idx}
                        className="d-flex align-items-center px-2 py-2 my-1"
                        style={{
                          fontSize: 14,
                          border: "1px solid #ddd",
                          borderRadius: 6,
                          cursor: "pointer",
                        }}
                      >
                        {/* <input
              type="checkbox"
              onChange={(e) => handleCheckboxChange(e, file)}
              checked={selectedApprovedFiles.includes(file)}
              className="me-2"
            /> */}
                        <span>{file?.filename}</span>
                      </div>
                    ))}
                  </>
                ) : (
                  <div className="text-muted" style={{ fontSize: 14 }}>
                    Empty
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <>
            {/* MOBILE — unchanged */}
            <Button
              variant="light"
              style={styles.floatingFilesBtn}
              onClick={() => setFilesOpen(true)}
            >
              <i className="bi bi-folder2-open me-2"></i>
              Show Files
            </Button>

            <Offcanvas
              show={filesOpen}
              onHide={() => setFilesOpen(false)}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Files</Offcanvas.Title>
              </Offcanvas.Header>

              <Offcanvas.Body>
                {/* FILTERS */}
                <h6 className="fw-bold">Filters</h6>

                <select
                  className="form-select mb-2"
                  value={selectedCategory}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value);
                    setSelectedSubcategory("all");
                  }}
                >
                  {categories.map((category) => (
                    <option key={category} value={category}>
                      {category === "all" ? "All Categories" : category}
                    </option>
                  ))}
                </select>

                {/* SUBCATEGORY */}
                <select
                  className="form-select mb-3"
                  value={selectedSubcategory}
                  onChange={(e) => setSelectedSubcategory(e.target.value)}
                  disabled={!selectedCategory}
                >
                  {subcategories.map((subcategory) => (
                    <option key={subcategory} value={subcategory}>
                      {subcategory === "all"
                        ? "All Subcategories"
                        : subcategory}
                    </option>
                  ))}
                </select>

                <button
                  className="btn btn-sm btn-outline-secondary w-100 mb-3"
                  onClick={() => {
                    setSelectedCategory("");
                    setSelectedSubcategory("");
                  }}
                >
                  Clear Filters
                </button>

                {/* META */}
                <div style={{ fontSize: 12, color: "#777" }}>
                  Last Synced:{" "}
                  {lastSynced ? new Date(lastSynced).toLocaleString() : "N/A"}
                </div>

                {/* APPROVED FILES */}
                <h6 className="mt-3 fw-bold">Approved Files</h6>

                {filteredFiles?.length > 0 ? (
                  filteredFiles.map((file, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center px-2 py-2 my-1"
                      style={{
                        fontSize: 14,
                        border: "1px solid #ddd",
                        borderRadius: 6,
                        cursor: "pointer",
                      }}
                    >
                      <input type="checkbox" className="me-2" />
                      <span>{file?.filename}</span>
                    </div>
                  ))
                ) : (
                  <div className="text-muted" style={{ fontSize: 13 }}>
                    No files found
                  </div>
                )}

                {/* UNAPPROVED FILES */}
                <h6 className="mt-4 fw-bold">Unapproved Files</h6>

                {filesForApproval?.length > 0 ? (
                  filesForApproval.map((file, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center px-2 py-2 my-1"
                      style={{
                        fontSize: 14,
                        border: "1px solid #ddd",
                        borderRadius: 6,
                        cursor: "pointer",
                      }}
                    >
                      <span>{file?.filename}</span>
                    </div>
                  ))
                ) : (
                  <div className="text-muted" style={{ fontSize: 14 }}>
                    Empty
                  </div>
                )}
              </Offcanvas.Body>
            </Offcanvas>
          </>
        )}
      </div>
      {showAdminModal && (
        <AdminModel
          onClose={() => setShowAdminModal(false)}
          currentTeamName={currentTeamName}
          userEmail={userEmail}
          switchTeams={switchTeams}
          fullTeam={fullTeam}
          filesForApproval={filesForApproval}
          lastSynced={lastSynced}
          handleSyncFiles={handleSyncFiles}
          handleCheckSyncStatus={handleCheckSyncStatus}
          filenames={filenames}
          handleDeleteFile={handleDeleteFile}
          selectedTeamId={selectedTeamId}
          teamStorageUsage={teamStorageUsage}
        />
      )}

      {teamMembersDialoag && (
        <Modal
          show={teamMembersDialoag}
          onHide={() => setTeamMembersDialog(false)}
          centered
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>Team Members</Modal.Title>
            <button
              type="button"
              onClick={() => setTeamMembersDialog(false)}
              style={{
                border: "none",
                fontSize: 24,
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ×
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <tbody>
                  <div className="files-for-approval mt-1">
                    {/* <h3>Files Pending Approval</h3> */}
                    <ul>
                      {teamMembers.map((file, index) => (
                        <li
                          key={file.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                          }}
                        >
                          <div>
                            <span
                              className="file-name"
                              style={{ marginRight: "10px" }}
                            >
                              {file.email}
                            </span>
                          </div>
                          <div>
                            <button
                              style={{
                                padding: "5px 10px",
                                backgroundColor: "#3e826d",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                            >
                              {file.role}
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </tbody>
              </table>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setTeamMembersDialog(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* ================= TOOLS POPUP ================= */}
      {showTools && !showAdminModal && (
        <div
          style={{
            position: "fixed",
            bottom: minimizedTools ? 20 : 90,
            right: 20,
            width: minimizedTools ? 220 : 320,
            height: minimizedTools ? 50 : 320,
            background: "white",
            borderRadius: 12,
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            transition: "all 0.3s ease",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              background: "#0E5E3D",
              color: "white",
              padding: "8px 12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <strong style={{ fontSize: 14 }}>Tools</strong>

            <div style={{ display: "flex", gap: 10 }}>
              {/* Minimize */}
              <i
                className={`bi ${minimizedTools ? "bi-plus-lg" : "bi-dash-lg"}`}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setMinimizedTools(!minimizedTools);
                }}
              ></i>

              {/* Close */}
              <i
                className="bi bi-x-lg"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowTools(false);
                  setMinimizedTools(false);
                }}
              ></i>
            </div>
          </div>

          {/* BODY */}
          {!minimizedTools && (
            <div
              style={{
                padding: 15,
                flexGrow: 1,
                overflowY: "auto",
              }}
            >
              <div
                className={`mb-3 p-2 border rounded ${
                  responseType === "Text" ? "bg-success text-white" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setResponseType("Text")}
              >
                Text
              </div>

              {/* <div
                className={`mb-3 p-2 border rounded ${
                  responseType === "Analysis" ? "bg-success text-white" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setResponseType("Analysis")}
              >
                Analysis
              </div> */}

              <div
                className={`mb-3 p-2 border rounded ${
                  responseType === "Canvas" ? "bg-success text-white" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setResponseType("Canvas")}
              >
                Canvas
              </div>

              <div
                className={`p-2 mb-3 border rounded ${
                  responseType === "benchmarking" ? "bg-success text-white" : ""
                }`}
                style={{
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                }}
                onClick={() => {
                  setShowBenchmarkModal(true);
                  setResponseType("benchmarking");
                }}
              >
                <div style={{ fontWeight: 500, fontSize: 14 }}>
                  ⚡ Quick Benchmarking
                </div>

                {benchmarkRunning && (
                  <div style={{ marginTop: 10 }}>
                    {/* Spinner + text */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 12,
                      }}
                    >
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                        style={{ width: 14, height: 14 }}
                      />
                      <span>Generating benchmark report...</span>
                    </div>

                    {/* Progress bar */}
                    <div
                      style={{
                        height: 6,
                        background: "#e9ecef",
                        borderRadius: 20,
                        marginTop: 8,
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          background:
                            "linear-gradient(90deg,#0E5E3D,#2ecc71,#0E5E3D)",
                          backgroundSize: "200% 100%",
                          animation: "benchmarkLoading 1.5s infinite linear",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div
                className={`p-2 mb-3 border rounded ${
                  responseType === "esap" ? "bg-success text-white" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowESAPModal(true);
                  setResponseType("esap");
                }}
              >
                <div style={{ fontWeight: 500, fontSize: 14 }}>
                  📊 ESAP Compliance
                </div>

                {esapRunning && (
                  <div style={{ marginTop: 10 }}>
                    <div className="d-flex align-items-center gap-2">
                      <div className="spinner-border spinner-border-sm" />
                      <span style={{ fontSize: 12 }}>
                        Running ESAP compliance check...
                      </span>
                    </div>

                    <div
                      style={{
                        height: 6,
                        background: "#e9ecef",
                        borderRadius: 20,
                        marginTop: 8,
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          background:
                            "linear-gradient(90deg,#0E5E3D,#2ecc71,#0E5E3D)",
                          backgroundSize: "200% 100%",
                          animation: "benchmarkLoading 1.5s infinite linear",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div
                className={`p-3 border rounded ${
                  responseType === "esdd" ? "bg-success text-white" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowESDDModal(true);
                  setResponseType("esdd");
                }}
              >
                <div style={{ fontWeight: 500, fontSize: 14 }}>
                  📑 ESDD (Due Diligence)
                </div>

                {esddRunning && (
                  <div style={{ marginTop: 10 }}>
                    <div className="d-flex align-items-center gap-2">
                      <div className="spinner-border spinner-border-sm" />
                      <span style={{ fontSize: 12 }}>
                        Running due diligence analysis...
                      </span>
                    </div>

                    <div
                      style={{
                        height: 6,
                        background: "#e9ecef",
                        borderRadius: 20,
                        marginTop: 8,
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          background:
                            "linear-gradient(90deg,#0E5E3D,#2ecc71,#0E5E3D)",
                          backgroundSize: "200% 100%",
                          animation: "benchmarkLoading 1.5s infinite linear",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {showBenchmarkModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px", // added
            overflowY: "auto", // added
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 500,
              background: "white",
              borderRadius: 12,
              padding: 20,
              maxHeight: "90vh", // added
              overflowY: "auto", // added
            }}
          >
            <h5>Quick Benchmarking</h5>

            <p style={{ fontSize: 13, color: "#666" }}>
              Select Knowledge Base files or upload new files.
              <br />
              Maximum 5 files allowed.
            </p>

            {/* FILE UPLOAD */}
            <div
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => document.getElementById("benchmarkUpload").click()}
              style={{
                border: "2px dashed #ccc",
                borderRadius: 10,
                padding: 30,
                textAlign: "center",
                cursor: "pointer",
                background: dragActive ? "#f5f5f5" : "white",
                transition: "0.2s",
              }}
            >
              <div style={{ fontSize: 14, color: "#666" }}>
                Drag & Drop files here
              </div>

              <div style={{ fontSize: 12, marginTop: 5 }}>
                or click to upload
              </div>

              <input
                id="benchmarkUpload"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={(e) => handleBenchmarkFiles(e.target.files)}
              />
            </div>

            {/* Upload to Knowledge Base Prompt */}
            {askUploadKB && benchmarkLocalFiles.length > 0 && (
              <div
                style={{
                  marginTop: 15,
                  padding: 10,
                  border: "1px solid #eee",
                  borderRadius: 8,
                  background: "#fafafa",
                }}
              >
                <label style={{ fontSize: 13 }}>
                  Upload these files to Knowledge Base?
                </label>

                <div style={{ marginTop: 8 }}>
                  <button
                    className="btn btn-sm btn-outline-success me-2"
                    onClick={() => uploadFilesToKB()}
                  >
                    Yes
                  </button>

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setAskUploadKB(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            )}

            {/* KB FILE SELECTOR */}
            <div
              style={{
                marginTop: 15,
                border: "1px solid #eee",
                borderRadius: 8,
                padding: 10,
                maxHeight: 150,
                overflowY: "auto",
              }}
            >
              <strong style={{ fontSize: 13 }}>
                Select from Knowledge Base
              </strong>

              {filteredFiles?.length > 0 ? (
                filteredFiles.map((file, idx) => (
                  <div
                    key={idx}
                    className="d-flex align-items-center mt-2"
                    style={{ fontSize: 13 }}
                  >
                    <input
                      type="checkbox"
                      className="me-2"
                      checked={benchmarkKBFiles.includes(file?.filename)}
                      onChange={() => handleKBFileSelect(file)}
                    />
                    <span>{file?.filename}</span>
                  </div>
                ))
              ) : (
                <div style={{ fontSize: 12, color: "#999", marginTop: 5 }}>
                  No files available
                </div>
              )}
            </div>

            <strong style={{ fontSize: 13 }}>Selected Files</strong>

            {/* Local uploaded files */}
            {benchmarkLocalFiles.map((file, i) => (
              <div
                key={i}
                style={{
                  fontSize: 13,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 6,
                }}
              >
                <span>📁 {file.name}</span>

                <span
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => removeLocalFile(i)}
                >
                  ✕
                </span>
              </div>
            ))}

            {/* KB selected files */}
            {benchmarkKBFiles.map((file, i) => (
              <div
                key={i}
                style={{
                  fontSize: 13,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 6,
                }}
              >
                <span>🧠 {file}</span>

                <span
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => removeKBFile(file)}
                >
                  ✕
                </span>
              </div>
            ))}

            {/* STANDARD TOGGLE */}
            <div style={{ marginTop: 20 }}>
              <label style={{ marginRight: 10 }}>Standard:</label>

              <button
                type="button"
                onClick={() => setBenchmarkStandard("ifc")}
                style={{
                  backgroundColor:
                    benchmarkStandard === "ifc" ? "#212529" : "transparent",
                  color: benchmarkStandard === "ifc" ? "#fff" : "#212529",
                  border: "1px solid #212529",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  marginRight: "8px",
                }}
              >
                IFC
              </button>

              <button
                type="button"
                onClick={() => setBenchmarkStandard("ebrd")}
                style={{
                  backgroundColor:
                    benchmarkStandard === "ebrd" ? "#212529" : "transparent",
                  color: benchmarkStandard === "ebrd" ? "#fff" : "#212529",
                  border: "1px solid #212529",
                  padding: "4px 12px",
                  borderRadius: "4px",
                }}
              >
                EBRD
              </button>
            </div>

            {/* ACTION BUTTONS */}
            <div
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap", // added
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => setShowBenchmarkModal(false)}
              >
                Cancel
              </button>

              <button className="btn btn-success" onClick={startBenchmark}>
                Start Benchmarking
              </button>
            </div>
          </div>
        </div>
      )}
      {showESAPModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px", // added
            overflowY: "auto", // added
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 500,
              background: "white",
              borderRadius: 12,
              padding: 20,
              maxHeight: "90vh", // added
              overflowY: "auto", // added
            }}
          >
            <h5>ESAP Compliance</h5>

            {/* ERROR */}
            {esapError && (
              <div className="alert alert-danger py-2 mt-2">{esapError}</div>
            )}

            {/* STEPS */}
            <div style={{ marginTop: 10, fontSize: 13 }}>
              <div style={{ marginBottom: 5 }}>
                <strong>Step 1:</strong> Upload at least one ESAP demo file
              </div>
              <div>
                <strong>Step 2:</strong> Select at least one file from Knowledge
                Base
              </div>
            </div>

            <p style={{ fontSize: 12, color: "#666", marginTop: 8 }}>
              Max 5 files allowed.
            </p>

            {/* DRAG & DROP */}
            <div
              onDragOver={(e) => {
                e.preventDefault();
              }}
              onDrop={(e) => {
                e.preventDefault();
                const files = Array.from(e.dataTransfer.files);

                if (files.length + esapLocalFiles.length > 5) {
                  setEsapError("Maximum 5 files allowed.");
                  return;
                }

                setEsapError("");
                setEsapLocalFiles((prev) => [...prev, ...files]);
                setEsapAskUploadKB(true);
              }}
              onClick={() => document.getElementById("esapUpload").click()}
              style={{
                border: "2px dashed #ccc",
                padding: 30,
                borderRadius: 10,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <input
                id="esapUpload"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={(e) => {
                  const files = Array.from(e.target.files);

                  if (files.length + esapLocalFiles.length > 5) {
                    setEsapError("Maximum 5 files allowed.");
                    return;
                  }

                  setEsapError("");
                  setEsapLocalFiles((prev) => [...prev, ...files]);
                  setEsapAskUploadKB(true);
                }}
              />
              Drag & Drop files or click to upload
            </div>

            {/* Upload to KB */}
            {esapAskUploadKB && esapLocalFiles.length > 0 && (
              <div style={{ marginTop: 10 }}>
                Upload to Knowledge Base?
                <br />
                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => uploadESAPFilesToKB()}
                  >
                    Yes
                  </button>

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setEsapAskUploadKB(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            )}

            {/* KB FILE SELECTOR */}
            <div
              style={{
                marginTop: 15,
                border: "1px solid #eee",
                borderRadius: 8,
                padding: 10,
                maxHeight: 150,
                overflowY: "auto",
              }}
            >
              <strong style={{ fontSize: 13 }}>
                Select from Knowledge Base
              </strong>

              {filteredFiles?.length > 0 ? (
                filteredFiles.map((file, idx) => (
                  <div
                    key={idx}
                    className="d-flex align-items-center mt-2"
                    style={{ fontSize: 13 }}
                  >
                    <input
                      type="checkbox"
                      className="me-2"
                      checked={esapKBFiles.includes(file?.filename)}
                      onChange={() => handleESAPKBFileSelect(file)}
                    />
                    <span>{file?.filename}</span>
                  </div>
                ))
              ) : (
                <div style={{ fontSize: 12, color: "#999", marginTop: 5 }}>
                  No files available
                </div>
              )}
            </div>

            {/* FILE LIST */}
            <div style={{ marginTop: 15 }}>
              {esapLocalFiles.map((f, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    fontSize: 13,
                    marginTop: 6,
                    wordBreak: "break-word",
                  }}
                >
                  <span>{f.name}</span>

                  <span
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontWeight: "bold",
                      marginLeft: 10,
                    }}
                    onClick={() =>
                      setEsapLocalFiles((prev) =>
                        prev.filter((_, index) => index !== i)
                      )
                    }
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>

            {/* ACTIONS */}
            <div
              className="mt-3 d-flex justify-content-end"
              style={{
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => setShowESAPModal(false)}
              >
                Cancel
              </button>

              <button className="btn btn-success" onClick={startESAPCompliance}>
                Run ESAP
              </button>
            </div>
          </div>
        </div>
      )}

      {showESDDModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px", // added
            overflowY: "auto", // added
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 500,
              background: "white",
              borderRadius: 12,
              padding: 20,
              maxHeight: "90vh", // added
              overflowY: "auto", // added
            }}
          >
            <h5>ESDD (Due Diligence)</h5>

            {/* ERROR */}
            {esddError && (
              <div className="alert alert-danger py-2 mt-2">{esddError}</div>
            )}

            {/* DRAG & DROP */}
            <div
              onDragOver={(e) => e.preventDefault()}
              onClick={() => document.getElementById("esddUpload").click()}
              onDrop={(e) => {
                e.preventDefault();
                const files = Array.from(e.dataTransfer.files);

                setEsddError("");
                setEsddLocalFiles((prev) => [...prev, ...files]);
                setEsddAskUploadKB(true);
              }}
              style={{
                border: "2px dashed #ccc",
                borderRadius: 10,
                padding: 30,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <input
                id="esddUpload"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={(e) => {
                  const files = Array.from(e.target.files);

                  setEsddError("");
                  setEsddLocalFiles((prev) => [...prev, ...files]);
                  setEsddAskUploadKB(true);
                }}
              />
              Drag & Drop files or click to upload
            </div>

            {/* Upload to KB */}
            {esddAskUploadKB && esddLocalFiles.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <span>Upload these files to Knowledge Base?</span>
                <br />

                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => uploadESDDFilesToKB()}
                  >
                    Yes
                  </button>

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setEsddAskUploadKB(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            )}

            {/* KB FILE SELECTOR */}
            <div
              style={{
                marginTop: 15,
                border: "1px solid #eee",
                borderRadius: 8,
                padding: 10,
                maxHeight: 150,
                overflowY: "auto",
              }}
            >
              <strong style={{ fontSize: 13 }}>
                Select from Knowledge Base
              </strong>

              {filteredFiles?.length > 0 ? (
                filteredFiles.map((file, idx) => (
                  <div
                    key={idx}
                    className="d-flex align-items-center mt-2"
                    style={{ fontSize: 13 }}
                  >
                    <input
                      type="checkbox"
                      className="me-2"
                      checked={esddKBFiles.includes(file?.filename)}
                      onChange={() => handleESDDKBFileSelect(file)}
                    />
                    <span>{file?.filename}</span>
                  </div>
                ))
              ) : (
                <div style={{ fontSize: 12, color: "#999", marginTop: 5 }}>
                  No files available
                </div>
              )}
            </div>

            {/* FILE LIST */}
            <div style={{ marginTop: 15 }}>
              <strong style={{ fontSize: 13 }}>Selected Files</strong>

              {/* LOCAL */}
              {esddLocalFiles.map((file, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center mt-2 px-2 py-1"
                  style={{
                    background: "#f8f9fa",
                    borderRadius: 6,
                    fontSize: 13,
                    wordBreak: "break-word", // added
                  }}
                >
                  <span>📁 {file.name}</span>

                  <span
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: 10,
                      flexShrink: 0,
                    }}
                    onClick={() =>
                      setEsddLocalFiles((prev) =>
                        prev.filter((_, index) => index !== i)
                      )
                    }
                  >
                    ✕
                  </span>
                </div>
              ))}

              {/* KB */}
              {esddKBFiles.map((file, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center mt-2 px-2 py-1"
                  style={{
                    background: "#eef6ff",
                    borderRadius: 6,
                    fontSize: 13,
                    wordBreak: "break-word", // added
                  }}
                >
                  <span>🧠 {file}</span>

                  <span
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: 10,
                      flexShrink: 0,
                    }}
                    onClick={() =>
                      setEsddKBFiles((prev) => prev.filter((f) => f !== file))
                    }
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>

            {/* STANDARD */}
            <div style={{ marginTop: 20 }}>
              <label style={{ marginRight: 10 }}>Standard:</label>

              <button
                className={`btn btn-sm ${
                  esddStandard === "ifc" ? "btn-dark" : "btn-outline-dark"
                }`}
                onClick={() => setEsddStandard("ifc")}
              >
                IFC
              </button>

              <button
                className={`btn btn-sm ms-2 ${
                  esddStandard === "ebrd" ? "btn-dark" : "btn-outline-dark"
                }`}
                onClick={() => setEsddStandard("ebrd")}
              >
                EBRD
              </button>
            </div>

            {/* ACTIONS */}
            <div
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap", // added
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => setShowESDDModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-success"
                onClick={startESDD}
                disabled={!esddStandard}
              >
                Start Analysis
              </button>
            </div>
          </div>
        </div>
      )}

      {openModule && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 400,
              background: "white",
              borderRadius: 12,
              padding: 20,
              textAlign: "center",
            }}
          >
            <h5>Upload to Knowledge Base</h5>

            <p style={{ fontSize: 14, color: "#666" }}>
              Do you want to upload this document to the Knowledge Base?
            </p>

            <div
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <button
                className="btn btn-success"
                onClick={() => {
                  // 👉 call your KB upload API here
                  handleUploadToKB(); // create this
                  setOpenModule(false);
                }}
              >
                Yes
              </button>

              <button
                className="btn btn-secondary"
                onClick={() => {
                  handleUploadToKB();
                  setOpenModule(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
